import classNames from 'classnames';
import { ISnowStatus, OpenFlag } from 'api/resort/types';
import { SnowUnit } from 'components/blocks/Unit';

import cellStyles from './styles.module.scss';

interface ISnowfallCellProps {
  openFlag?: OpenFlag
  currentWeather?: ISnowStatus
  noValue: string
  is72hoursReport?: boolean
}

const SnowfallCell = ({
  openFlag, currentWeather, noValue, is72hoursReport,
}: ISnowfallCellProps) => {
  const value = is72hoursReport ? currentWeather?.last72 : currentWeather?.last24;
  const showSnowValue = !!value && (openFlag !== OpenFlag.NoReportAvailable);

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      { showSnowValue
        ? <SnowUnit values={value} />
        : noValue }
      <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>
    </span>
  );
};

export default SnowfallCell;
